import { Lock, MicrosoftOutlookLogo, ShieldCheck } from "@phosphor-icons/react";

import { Button } from "../../../components/ui/button";
import { DD_FOLDER_NAME } from "./model";

export function ConnectScreen({ onGrantAccess, isConnecting }) {
  return (
    <div className="flex-1 overflow-y-auto bg-slate-50 px-8 py-8">
      <div className="max-w-xl mx-auto" data-testid="onedrive-connect-section">
        <div className="bg-white border border-slate-200 p-8 text-center">
          <div className="w-16 h-16 bg-[#0078D4]/10 flex items-center justify-center mx-auto mb-5 rounded-sm">
            <ShieldCheck size={32} className="text-[#0078D4]" />
          </div>
          <h2 className="font-cabinet text-xl font-bold text-slate-900 tracking-tight mb-2">Connect to OneDrive</h2>
          <p className="text-sm text-slate-500 leading-relaxed mb-6 max-w-sm mx-auto">
            Grant server access to browse and manage your{" "}
            <span className="font-semibold text-slate-700">"{DD_FOLDER_NAME}"</span> folder.
          </p>
          <Button onClick={onGrantAccess} disabled={isConnecting} data-testid="connect-onedrive-btn" className="bg-[#0078D4] hover:bg-[#006CBE] text-white px-6">
            {isConnecting ? <><MicrosoftOutlookLogo size={15} className="mr-2 animate-spin" />Connecting…</> : <><MicrosoftOutlookLogo size={15} className="mr-2" />Grant Server Access</>}
          </Button>
        </div>
        <div className="mt-4 flex items-start gap-2.5 bg-blue-50 border border-blue-200 p-3">
          <Lock size={14} className="text-blue-600 flex-shrink-0 mt-0.5" />
          <p className="text-xs text-blue-700 leading-relaxed">
            <span className="font-semibold">Secure OAuth 2.0 PKCE connection.</span>{" "}
            Access can be revoked at any time from your Microsoft account settings or from AI Automations.
          </p>
        </div>
      </div>
    </div>
  );
}
